import React, { useEffect, useState } from 'react';
import { auth } from '../config/firebase-config';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const { FullName } = location.state || {};

  useEffect(() => {
    console.log(FullName);
    
    const checkAuthState = () => {
      auth.onAuthStateChanged((userCred) => {
        if (userCred) {
          window.localStorage.setItem("auth", "true");
          window.localStorage.setItem("user", JSON.stringify(userCred));
          userCred.getIdToken()
            .then(token => {
              setToken(token);
              if (userCred.emailVerified) {
                // Get FullName from localStorage if not available in state
                const storedFullName = localStorage.getItem('fullName') || FullName;
                navigate('/user-type-selection', { 
                  state: { 
                    token, 
                    FullName: storedFullName  // Pass the stored FullName
                  } 
                });
              }
            })
            .catch(err => {
              console.log("Error", err);
            });
        }
      });
    };

    const interval = setInterval(checkAuthState, 2000);

    return () => clearInterval(interval);
  }, [navigate, FullName]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.reload(); // Refresh the entire browser window every 2 seconds
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="verify-email-container">
      <h1>Verify Your Email</h1>
      <p>We've sent a verification link to your email address.</p>
      <p>Please check your inbox and click on the link to verify your account.</p>
      <div className="email-icon">
        📧
      </div>
      <p>If you don't see the email, please check your spam folder.</p>
      <h1>Dont close this Tab</h1>
     {/* <button className="resend-button">Resend Verification Email</button>*/}
    </div>
  );
};

export default VerifyEmail;